var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6564 2.8125H9.84394V1.875C9.84394 1.35938 9.42207 0.9375 8.90644 0.9375H6.09395C5.57832 0.9375 5.15645 1.35938 5.15645 1.875V2.8125H2.34395C1.7252 2.8125 1.7252 3.75 2.34395 3.75H2.83145L3.23926 12.7219C3.27207 13.4766 3.89082 14.0625 4.64551 14.0625H10.3549C11.1096 14.0625 11.7236 13.4719 11.7611 12.7219L12.1689 3.75H12.6564C13.2752 3.75 13.2752 2.8125 12.6564 2.8125ZM6.09395 1.875H8.90644V2.8125H6.09395V1.875ZM10.8236 12.675C10.8143 12.9281 10.608 13.125 10.3549 13.125H4.64551C4.39238 13.125 4.19082 12.9281 4.17676 12.6797L3.76895 3.75H11.2268L10.8189 12.675H10.8236Z",
    fill: "#FF4C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 5.62422V11.2492C5.625 11.868 6.5625 11.868 6.5625 11.2492V5.62422C6.5625 5.00547 5.625 5.00547 5.625 5.62422Z",
    fill: "#FF4C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 5.62422V11.2492C8.4375 11.868 9.375 11.868 9.375 11.2492V5.62422C9.375 5.00547 8.4375 5.00547 8.4375 5.62422Z",
    fill: "#FF4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5b8416f8ff8f28fee2159e02052d8c6f.svg";
export { ForwardRef as ReactComponent };